export default __webpack_public_path__ + "static/Brian-Manning-3d0518721f18aad0ee7bf5d3bc2f4d2a.jpeg";